import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import langInvestWordLang from '../../../apps/investor/langs/langInvestWordLang';

type AppFormatDateTimeProps = {
	date?: Date | string | null;
};

const AppFormatDateTime = (props: AppFormatDateTimeProps) => {
	const { date } = props;
	const { t } = useTranslation();
	return <>{date ? moment(date).format('DD/MM/YYYY HH:mm') : t(langInvestWordLang.nc.tag)}</>;
};

export default AppFormatDateTime;
